import * as React from 'react';
import Box from '@mui/material/Box';
import {convertFromRaw} from 'draft-js';
// @ts-ignore
import {stateToHTML} from 'draft-js-export-html';

import {
  GridRowModesModel,
  GridRowModes,
  GridActionsCellItem,
  GridRowId,
  useGridApiRef,
  DataGridProProps,
  GridColumnMenu,
} from '@mui/x-data-grid';
import {
  DataGridPro,
  GridColumnMenuFilterItem,
  GridColumnMenuPinningItem,
  GridColumnMenuSortItem,
  gridFilteredDescendantCountLookupSelector,
  useGridSelector,
  GridColDef,
  GridToolbarContainer,
  gridFilterModelSelector,
  GridFilterModel,
  GridLogicOperator,
  GridSortModel,
  GridPaginationModel,
  GridPagination,
  GridToolbarFilterButton,
  GridFilterInputDate,
  gridFilteredSortedRowEntriesSelector,
  getGridStringOperators,
} from '@mui/x-data-grid-pro';

import {memo, useCallback, useEffect, useMemo, useRef, useState} from 'react';
import ReactDOM from 'react-dom';

import api from '../../services/api';
import {
  IconButton,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Button,
  Typography,
  TextField,
  Autocomplete,
  FormControl,
} from '@mui/material';

import Tooltip from '@mui/material/Tooltip';
import {TableHeader} from './NewTableHeader';
import {toaster} from '../../services/toaster';
import {Entity} from '../../types/entities/Entity';
import {SchemaWithClient} from '../../types/SchemaWithClient';
import {noOp} from '../../services/noOp';
import _, {debounce} from 'lodash';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {Cell} from './cell/Cell';
import {ColumnMenu} from './ColumnMenu';
import {SelectCell} from './cell/SelectCell';
import {SetCell} from './cell/SetCell';
import {NumberCell} from './cell/NumberCell';
import Link from '@mui/material/Link';
import {datagridColors} from '../../assets/datagridStyles.js';
import AddIcon from '@mui/icons-material/Add';
import {ButtonCell} from './cell/ButtonCell';
import {StatusCell} from './cell/StatusCell';
import {ReservationDialog} from '../Group/ReservationDialog';
import {useStateContext} from '../../hooks/useStateContext';
import {toISODateString} from '../../services/toISODateString';
import BasicSelectMUI from './fields/BasicSelectMUI';
import SingleSelectMUI from './fields/SingleSelectMUI';
import {DateCell} from './cell/DateCell';
import {
  AttachFileRounded,
  DeleteSweepRounded,
  DifferenceRounded,
  DownloadRounded,
  FilterAltOutlined, LinkOffRounded, LinkRounded,
  SaveAltRounded,
  ViewWeekRounded,
} from '@mui/icons-material';
import {LoadingButton} from '@mui/lab';
import MultiSelectMUI from './fields/MultiSelectMUI';
import CancelIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import {TimeEditCell} from './cell/TimeEditCell';
import {DataGridSelectFilter} from './filters/DataGridSelectFilter';
import {FilterList} from '@mui/icons-material';
import toast from 'react-hot-toast';
import {FloatingMenu} from './FloatingMenu';
import {DateTimeCell} from './cell/DateTimeCell';
import {PriceWithCurrencyCell} from './cell/PriceWithCurrencyCell';
import {SetGuideReservationCell} from './cell/SetGuideReservationCell';
import MultiSelectGuideMUI from './fields/MultiSelectGuideMUI';
import {DataGridMultiSelectFilter} from './filters/DataGridMultiSelectFilter';
import {DataGridGuideMultiSelectFilter} from './filters/DataGridGuideMultiSelectFilter';
import SingleSelectAddressMUI from './fields/SingleSelectAddressMUI';
import NumberEditCell from './fields/NumberEditCell';
import {AddressCell} from './cell/AddressCell';
import {SetGuideCell} from './cell/SetGuideCell';
import {SetAddressLineCell} from './cell/SetAddressLineCell';
import {generateXLSFile} from '../../utils/excelUtils';
import {OpenReservationCell} from './cell/OpenReservationCell';
import {getSchemaColumns} from './utils/schemaUtils';
import {isJson} from './utils/validationUtils';
import {useFakeMutation} from './hooks/useFakeMutation';
import ColumnReorderHandler from './hooks/useColumnReorder';
import FastFilters from './layout/FastFilters';
import {useSocketContext} from '../../contexts/SocketContext';
import {hasPermissionByPriority} from '../../core/permissions/hasPermission';
import {ROLE_PRIORITIES} from '../../core/permissions/permissions';
import {
  CustomSortIconDesc,
  CustomSortIconAsc,
  CustomSortIcon,
} from './assets/icons/CustomIcons';
import ConfirmDialog from './layout/ConfirmDialog';
import {OfferDateCell} from './cell/OfferDateCell';
import {ServiceReservationModificationDialog} from './layout/ServiceReservationModificationDialog';
import Badge from '@mui/material/Badge';
import {useTheme} from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import {CostSummaryCell} from './cell/CostSummaryCell';
import {PriceSummaryCell} from './cell/PriceSummaryCell';
import {LinkCell} from './cell/LinkCell';
import {exportToXLSX} from './utils/exportToXLSX';
import {RichTextEditCell} from './cell/RichTextEditCell';
import {MultipleRowsCell} from './cell/MultipleRowsCell';
import {AccommodationAddressesCell} from './cell/AccommodationAddressesCell';
import PendingRowUpdateDialog from './layout/PendingRowUpdateDialog';
import PendingRowUpdateStatusDialog from './layout/PendingRowUpdateStatusDialog';
import {MultipleRowsSimpleCell} from "./cell/MultipleRowsSimpleCell";
import {GuideOptions} from "../Group/GuideOptionsDialog";
import AttachmentDialog from "./layout/AttachmentDialog";
import {LogDialog} from "./layout/LogDialog";
import {SummaryCell} from "./cell/SummaryCell";
import {ClickableStatusCell} from "./cell/ClickableStatusCell";

type GridRowModesModelType = typeof GridRowModesModel;
type GridRowIdType = typeof GridRowId;
type DataGridProPropsType = typeof DataGridProProps;

type Props<T extends Entity> = {
  columnMask?: Array<keyof T>;
  schema: SchemaWithClient<T>;
  isView?: boolean;
  onRowSelected?: (id?: number) => void;
  isLoaded?: (value?: boolean) => void;
  searchParams?: URLSearchParams;
  newEntityFixedValues?: Partial<T>;
  subViewId?: number;
  showCSVImport?: boolean;
  columnAligns?: Partial<Record<keyof T, string>>;
  viewId?: number;
  selectedRowId?: any;
  selectedGroupId?: any;
  pins?: any;
  hasSlidingPane?: boolean;
  setCurrentEditedRow?: (
    value?: any,
    openInFull?: boolean,
    isLocked?: boolean
  ) => void;
  currentEditedRow?: any;
  editingChip?: (value?: boolean) => void;
  showReservations?: any;
  onShowReservationsChange?: () => void;
  setCurrentAddNewRow?: (value?: any) => void;
  lastForceFetchedStamp?: number;
  setFunctionRef?: any;
  disabled?: boolean;
  reservationDialog?: any;
  openedPanel?: boolean;
  isInFullPanel?: boolean;
  onRowCountChange?: (rowCount: number) => void;
};

export default function FullFeaturedCrudGrid<T extends Entity>({
                                                                 columnMask,
                                                                 schema,
                                                                 isView,
                                                                 onRowSelected = noOp,
                                                                 searchParams,
                                                                 newEntityFixedValues,
                                                                 showCSVImport,
                                                                 subViewId,
                                                                 viewId,
                                                                 pins,
                                                                 selectedRowId,
                                                                 hasSlidingPane,
                                                                 setCurrentEditedRow,
                                                                 onShowReservationsChange,
                                                                 showReservations,
                                                                 currentEditedRow,
                                                                 setCurrentAddNewRow,
                                                                 lastForceFetchedStamp,
                                                                 setFunctionRef,
                                                                 disabled,
                                                                 reservationDialog,
                                                                 selectedGroupId,
                                                                 openedPanel,
                                                                 isInFullPanel,
                                                                 onRowCountChange,
                                                               }: Props<T>) {
  /* States */

  const themeQuery = useTheme();
  const isMobile = useMediaQuery(themeQuery.breakpoints.down('lg'));

  const [pinnedColumns, setPinnedColumns] = useState(
    pins && !isMobile
      ? pins
      : {
        left: ['actions'],
        right: [],
      }
  );

  const [pinnedRows, setPinnedRows] = useState<any>({
    top: [],
    bottom: schema?.hasSum ? [{id: 'SUM'}] : [],
  });
  const [popupState, setPopupState] = useState(false);
  const [highlightedRows, setHighlightedRows] = useState<any>([]);
  const [
    masterSettlementRiportLoading,
    setMasterSettlementRiportLoading,
  ] = useState(false);
  const [openedGuideOptions, setOpenedGuideOptions] = useState<any>(false);
  const [openedLogs, setOpenedLogs] = useState<any>(false);
  const [checkedRows, setCheckedRows] = useState<any>({});
  const [prevSchema, setPrevSchema] = useState(schema);
  const boxRef = useRef<any>(undefined);
  const gridRef = useRef<any>(undefined);
  const [visibleColumns, setVisibleColumns] = useState<any>(columnMask);
  const [fastSearchValue, setFastSearchValue] = useState<any>('');
  const [rowModesModel, setRowModesModel] = useState<GridRowModesModelType>({});
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 500000,
    page: 0,
  });
  const apiRef = useGridApiRef();
  const debouncedSetPaginationModel = _.debounce(setPaginationModel, 300);
  const [sortModel, setSortModel] = useState<any>([]);
  const [
    filterOriginalAndFinalPrice,
    setFilterOriginalAndFinalPrice,
  ] = useState<any>(false);
  const [state, setState] = useState({
    rows: [],
    loadedRows: false,
    rowCount: 0,
    isLoading: true,
  });
  const [fastFilters, setFastFilters] = useState([]);
  const [showDeleted, setShowDeleted] = useState(false);
  const [fastFilterValue, setFastFilterValue] = useState<any>({});
  const [
    fastFilterValueServiceProvider,
    setFastFilterValueServiceProvider,
  ] = useState<any>({});
  const [openedReservations, setOpenedReservations] = useState<any>(false);
  const [openAttachmentDialog, setOpenAttachmentDialog] = useState<any>(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState<any>(false);
  const [openDuplicateConfirmDialog, setOpenDuplicateConfirmDialog] = useState<any>(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const [openHeaderFilters, setOpenHeaderFilters] = useState(false);
  const [contextMenu, setContextMenu] = useState<any>(null);
  const [rightClickedRow, setRightClickedRow] = useState<any>(null);
  const [rowSelectionModel, setRowSelectionModel] = useState<any>([]);
  const [progressPercent, setProgressPercent] = useState<any>(null);
  const [filterModel, setFilterModel] = useState<GridFilterModel>({
    items: [],
    logicOperator: GridLogicOperator.And,
  });
  const autosizeOptions = {
    includeHeaders: true,
    includeOutliers: true,
    outliersFactor: 1.5,
    expand: false,
  };
  const [visibleRows, setVisibleRows] = useState([]);
  const {user} = useStateContext();
  const isAdmin = hasPermissionByPriority(user.roles, ROLE_PRIORITIES[1]);
  const {lockedRows, kickedRows} = useSocketContext();
  const [filterModelStatic, setFilterModelStatic] = useState<GridFilterModel>({
    items: [],
  });
  const [sortModelStatic, setSortModelStatic] = useState<GridSortModel>([]);
  const [paginationModelStatic, setPaginationModelStatic] = useState<
    GridPaginationModel
  >({
    page: 0,
    pageSize: 10,
  });

  useEffect(() => onRowCountChange && onRowCountChange(state.rowCount), [
    state.rowCount,
  ]);

  useEffect(() => {
    if (kickedRows.length > 0) {
      const latestKick = kickedRows[kickedRows.length - 1];

      setRowModesModel((prevRowModesModel: any) => {
        const updatedRows = {...prevRowModesModel};
        Object.keys(updatedRows).forEach((rowId) => {
          const rowData = apiRef.current.getRow(rowId);

          if (
            updatedRows[rowId].mode === GridRowModes.Edit &&
            rowData.id == latestKick.relation_id
          ) {
            updatedRows[rowId] = {
              mode: GridRowModes.View,
              ignoreModifications: false,
            };

            schema.client
              .deleteLock(rowData?.id, {
                schema: JSON.stringify(schema.client),
                view_table: schema.viewTable,
              })
              .then((result: any) => {
              });
          }
        });

        return updatedRows;
      });
    }
  }, [kickedRows]);

  const handleStateChange = (state: any) => {
    const visibleRowsModels = state.visibleRows;
    setVisibleRows(visibleRowsModels);
  };
  const handleOpenAttachments = (row: any) => {
    setOpenAttachmentDialog(row);
  };

  const columns: GridColDef[] = useMemo(() => {
    const columns = getSchemaColumns(schema, visibleColumns);

    const columnArray: any = {};

    columnArray[0] = {
      field: 'actions',
      type: 'actions',
      headerName: '#',
      cellClassName: 'actions',
      renderCell: (params: any) => {
        const currentPage = paginationModelStatic.page;
        const pageSize = paginationModelStatic.pageSize;

        const rowIndex =
          currentPage * pageSize +
          params.api.getRowIndexRelativeToVisibleRows(params.id) +
          1;

        const id = params.id;
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon/>}
              label="Save"
              sx={{
                color: 'primary.main',
              }}
              onClick={handleSaveClick(id)}
            />,
            <GridActionsCellItem
              icon={<CancelIcon/>}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(id)}
              color="inherit"
            />,
          ];
        }

        const hasAttachment = params.row?.has_attachments;

        return (
          <Badge
            variant="dot"
            invisible={!params.row?.notification_count}
            color="primary"
          >
            <Stack
              direction={'row'}
              alignItems={'center'}
              sx={{
                '& .MuiIconButton-root': {
                  padding: '2px'
                }
              }}
            >
              <Typography variant={'caption'}>
                {isNaN(rowIndex) ? '' : rowIndex}
              </Typography>
              {hasAttachment ? (
                <IconButton
                  size={'small'}
                  onClick={() => {
                    handleOpenAttachments(params.row);
                  }}
                >
                  <AttachFileRounded sx={{
                    fontSize: '12px'
                  }} color={'disabled'}/>
                </IconButton>
              ):(
                <></>
              )}
            </Stack>
          </Badge>
        );
      },
      getActions: (props: any) => {
        const id = props.id;
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon/>}
              label="Save"
              sx={{
                color: 'primary.main',
              }}
              onClick={handleSaveClick(id)}
            />,
            <GridActionsCellItem
              icon={<CancelIcon/>}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(id)}
              color="inherit"
            />,
          ];
        }

        // invisible={!props.row?.notification_count}

        return [
          <>
            <Badge
              variant="dot"
              invisible={!props.row?.notification_count}
              color="primary"
            >
              {!props.row?.is_group_item && props.id}
            </Badge>
          </>,
        ];
      },
      renderHeader: (props: any) => {
        return (
          <IconButton
            size={'small'}
            onClick={() => {
              setOpenHeaderFilters(!openHeaderFilters);
            }}
          >
            <FilterAltOutlined
              sx={{
                color: '#fff',
              }}
            />
          </IconButton>
        );
      },
    };

    columns.map((column, columnIndex) => {
      const columnSettings: any = {
        id: columnIndex + 1,
        field: column.id,
        headerName: column.name,
        editable: true,
        headerClassName: '',
        headerAlign: 'left',
        align: 'left',
        height: '10px',
      };

      if (!column?.name || column?.hideInTableView) {
        return false;
      }

      if (
        column.name.length < 2 ||
        (column?.url && column.url.includes('/statuses'))
      ) {
        columnSettings['maxWidth'] = 35;
      }

      columnSettings['type'] = column?.fieldType ? column?.fieldType : 'string';

      if (columnSettings['type'] === 'string' || columnSettings['type'] === 'array') {
        /* columnSettings['filterOperators'] = [
           {
             label: 'contains',
             value: 'contains',
             filterOperators: getGridStringOperators().filter(
               (op) => op.value === 'contains'
             ),
           },
           {
             label: 'equals',
             value: 'equals',
             filterOperators: getGridStringOperators().filter(
               (op) => op.value === 'equals'
             ),
           },
         ];*/
        columnSettings['filterOperators'] = getGridStringOperators().filter(
          (op) => op.value === 'contains' || op.value === 'equals'
        );

        columnSettings['renderCell'] = (props: any) => {
          return (
            <>
              {schema.treeData && props.field === 'name' ? (
                <CustomGridTreeDataGroupingCell {...props} />
              ) : (
                <>
                  {props.value === 'choose-package' ||
                  props.value === 'choose-staff' ||
                  props.value === 'choose-driver' ? (
                    <ButtonCell
                      props={props}
                      refreshData={() => {
                        fetchData();
                      }}
                    />
                  ) : (
                    <>
                      {props.value === 'open-reservations' ? (
                        <OpenReservationCell
                          props={props}
                          openReservation={() => {
                            const sendData: any = {
                              name:
                                schema?.pluralName === 'Activity Reservations'
                                  ? props?.row?.group?.name
                                    ? `${props?.row?.group?.name} - ${props?.row?.activity?.name}`
                                    : `${props?.row?.activity?.name}`
                                  : props?.row?.name,
                            };

                            if (
                              schema?.pluralName === 'Activity Reservations'
                            ) {
                              sendData.activity = props?.row?.activity;
                              sendData.activity_reservation = {
                                id: props?.row?.id,
                                name: props?.row?.activity?.name,
                              };
                              sendData.group = props?.row?.group;

                              if (props?.row?.is_group) {
                                sendData.activity.is_group = 1;
                              }
                            }

                            if (schema?.pluralName === 'Groups') {
                              sendData.group = {
                                id: props?.row?.id,
                                name: props?.row?.name,
                              };
                            }

                            setOpenedReservations(sendData);
                          }}
                        />
                      ) : (
                        <Cell props={props} isArray={columnSettings['type'] === 'array'}/>
                      )}
                    </>
                  )}
                </>
              )}
            </>
          );
        };
      }
      if (columnSettings['type'] === 'date') {
        columnSettings['renderCell'] = (props: any) => {
          if (props?.value === 'date-offer') {
            return (
              <OfferDateCell
                props={props}
                schema={schema}
                refresh={() => {
                  fetchData();
                }}
              />
            );
          }

          return <DateCell props={props} schema={schema}/>;
        };
        columnSettings['renderEditCell'] = (params: any) => {
          return (
            <input
              style={{
                background: 'transparent',
                width: '100%',
              }}
              type="date"
              value={params.value || ''}
              onChange={(event) =>
                params.api.setEditCellValue({
                  id: params.id,
                  field: params.field,
                  value: event.target.value || null,
                })
              }
            />
          );
        };
        columnSettings['type'] = 'string';
        columnSettings['filterOperators'] = [
          {
            label: 'equals',
            value: 'equals',
            getApplyFilterFn: (filterItem: any) => {
              if (!filterItem.value) return null;
              return (params: any) =>
                new Date(params.value).toDateString() ===
                new Date(filterItem.value).toDateString();
            },
            InputComponent: (props: any) => (
              <GridFilterInputDate {...props} type="date"/>
            ),
          },
          {
            label: 'greater than or equal',
            value: 'greaterThanOrEqual',
            getApplyFilterFn: (filterItem: any) => {
              if (!filterItem.value) return null;
              return (params: any) =>
                new Date(params.value) >= new Date(filterItem.value);
            },
            InputComponent: (props: any) => (
              <GridFilterInputDate {...props} type="date"/>
            ),
          },
          {
            label: 'less than or equal',
            value: 'lessThanOrEqual',
            getApplyFilterFn: (filterItem: any) => {
              if (!filterItem.value) return null;
              return (params: any) =>
                new Date(params.value) <= new Date(filterItem.value);
            },
            InputComponent: (props: any) => (
              <GridFilterInputDate {...props} type="date"/>
            ),
          },
        ];
      }
      if (columnSettings['type'] === 'dateTime') {
        columnSettings['valueGetter'] = (props: any) => {
          if (props?.value !== null && props?.value !== undefined) {
            const dateValue = new Date(props.value);
            return dateValue;
          } else {
            return null;
          }
        };
        columnSettings['renderCell'] = (props: any) => {
          return (
            <>
              <DateTimeCell props={props} schema={schema}/>
            </>
          );
        };
      }
      if (columnSettings['type'] === 'time') {
        columnSettings['renderCell'] = (params: any) => {
          if (params?.value === 'time-offer') {
            return (
              <OfferDateCell
                props={params}
                schema={schema}
                refresh={() => {
                  fetchData();
                }}
              />
            );
          }

          return <Cell props={params}/>;
        };
        columnSettings['renderEditCell'] = (params: any) => {
          return <TimeEditCell props={params} schema={schema}/>;
        };
      }
      if (columnSettings['type'] === 'textarea') {
        columnSettings['renderCell'] = ({value}: { value: any }) => {
          let options = {
            inlineStyles: {
              BOLD: {element: 'b'},
              ITALIC: {
                attributes: {class: 'foo'},
                style: {fontSize: 12},
              },
            },
            defaultBlockTag: 'div',
          };
          let html: any = '';
          if (value) {
            if (!isJson(value)) {
              html = value;
            } else {
              html = stateToHTML(convertFromRaw(JSON.parse(value)), options);
            }
          }
          return (
            <>
              <Tooltip
                title={<div dangerouslySetInnerHTML={{__html: html}}/>}
              >
                <div className="overflow-hidden text-ellipsis whitespace-nowrap">
                  <span
                    className={'w-full'}
                    dangerouslySetInnerHTML={{__html: html}}
                  ></span>
                </div>
              </Tooltip>
            </>
          );
        };
        columnSettings['sortable'] = false;
        columnSettings['maxWidth'] = 250;
        columnSettings['editable'] = false;
      }
      if (columnSettings['type'] === 'editable-textarea') {
        columnSettings['renderCell'] = ({value}: { value: any }) => {
          let options = {
            inlineStyles: {
              BOLD: {element: 'b'},
              ITALIC: {
                attributes: {class: 'foo'},
                style: {fontSize: 12},
              },
            },
            defaultBlockTag: 'div',
          };
          let html: any = '';
          if (value) {
            if (!isJson(value)) {
              html = value;
            } else {
              html = stateToHTML(convertFromRaw(JSON.parse(value)), options);
            }
          }
          return (
            <>
              <Tooltip
                title={<div dangerouslySetInnerHTML={{__html: html}}/>}
              >
                <div className="overflow-hidden text-ellipsis whitespace-nowrap">
                  <span
                    className={'w-full'}
                    dangerouslySetInnerHTML={{__html: html}}
                  ></span>
                </div>
              </Tooltip>
            </>
          );
        };
        columnSettings['sortable'] = false;
        columnSettings['maxWidth'] = 250;
        columnSettings['editable'] = true;
        columnSettings['renderEditCell'] = (params: any) => {
          return (
            <RichTextEditCell props={params} schema={schema} column={column}/>
          );
        };
      }
      if (columnSettings['type'] === 'number') {
        columnSettings['align'] = 'right';
        columnSettings['headerAlign'] = 'right';
        columnSettings['renderCell'] = (params: any) => {
          return <NumberCell props={params}/>;
        };
      }
      if (columnSettings['type'] === 'number-with-summary') {
        columnSettings['align'] = 'right';
        columnSettings['headerAlign'] = 'right';
        columnSettings['renderCell'] = (params: any) => {

          if (params?.id === 'SUM') {
            return (
              <SummaryCell
                props={params}
                schema={schema}
                apiRef={apiRef}
              />
            );
          }

          return <NumberCell props={params}/>;
        };
      }
      if (columnSettings['type'] === 'price') {
        columnSettings['headerAlign'] = 'right';
        columnSettings['align'] = 'right';
        columnSettings['renderCell'] = (params: any) => {
          if (params?.id === 'SUM') {
            return (
              <PriceSummaryCell
                props={params}
                schema={schema}
                apiRef={apiRef}
              />
            );
          }

          return <NumberCell props={params} price={true} double={false}/>;
        };
      }
      if (columnSettings['type'] === 'priceWithCurrency') {
        columnSettings['align'] = 'right';
        columnSettings['headerAlign'] = 'right';
        columnSettings['renderCell'] = (params: any) => {
          return <PriceWithCurrencyCell props={params}/>;
        };
        columnSettings['renderEditCell'] = (params: any) => {
          return <NumberEditCell params={params} column={column}/>;
        };
      }
      if (columnSettings['type'] === 'costs') {
        columnSettings['align'] = 'right';
        columnSettings['headerAlign'] = 'right';
        columnSettings['renderCell'] = (params: any) => {
          if (params?.id === 'SUM') {
            return (
              <CostSummaryCell props={params} schema={schema} apiRef={apiRef}/>
            );
          }
          return <NumberCell props={params} price={true} double={true}/>;
        };
      }
      if (columnSettings['type'] === 'link') {
        columnSettings['editable'] = false;
        columnSettings['renderCell'] = (params: any) => {
          const transformedValue =
            params?.value === undefined ? [] : params.value;
          return (
            <div className={'flex gap-[5px]'}>
              {transformedValue.map((row: any) => {
                return (
                  <Link
                    component="button"
                    onClick={(event) => {
                      if (setCurrentEditedRow) {
                        setCurrentEditedRow(row);
                      }
                    }}
                  >
                    {row?.name}
                  </Link>
                );
              })}
            </div>
          );
        };
      }
      if (columnSettings['type'] === 'text-link') {
        columnSettings['renderCell'] = (params: any) => {
          return (
            <div className={'flex gap-[5px]'}>
              <IconButton
                size={'small'}
                onClick={(event) => {
                  const url = params.value;
                  if (url) {
                    window.open(url, '_blank');
                  }
                }}
                disabled={!params?.value}
              >
                {params?.value ? (<LinkRounded fontSize={'small'} color={'primary'} />) : (<LinkOffRounded fontSize={'small'} />)}
              </IconButton>
            </div>
          );
        };
      }
      if (columnSettings['type'] === 'roadbook-file') {
        columnSettings['renderCell'] = (params: any) => {
          const hasRoadbook = !!params?.row?.roadbook_id; // boolean konvertálás
          return (
            <Box display="flex" alignItems="center" justifyContent="center" width="100%">
              {hasRoadbook ? (
                <Typography color="success.main">✔</Typography>
              ) : (
                <Typography color="error.main">✖</Typography>
              )}
            </Box>
          );
        };
      }
      if (columnSettings['type'] === 'download-filename') {
        columnSettings['renderCell'] = (params: any) => {
          const link = `/reservation-summaries/${params?.value}.xlsx`;
          return (
            <a href={link} target={'_blank'}>{params?.value}.xlsx</a>
          );
        };
      }
      if (column?.switchboard) {
        if (columnSettings['type'] === 'status') {
          columnSettings['renderCell'] = (props: any) => (
            <StatusCell props={props}/>
          );
        }
        else if (columnSettings['type'] === 'clickable-status') {
          columnSettings['renderCell'] = (props: any) => (
            <ClickableStatusCell props={props}/>
          );
        } else {
          columnSettings['renderCell'] = (props: any) => {
            if (
              props.value === 'choose-package' ||
              props.value === 'choose-staff' ||
              props.value === 'choose-driver' ||
              props.value === 'choose-vehicle'
            ) {
              return (
                <ButtonCell
                  props={props}
                  refreshData={() => {
                    fetchData();
                  }}
                />
              );
            }

            if (column?.fieldType === 'address') {
              return <AddressCell props={props}/>;
            }

            return <SelectCell props={props}/>;
          };
        }
        columnSettings['renderEditCell'] = (params: any) => {
          if (column?.url && column.url.includes('/statuses')) {
            return <BasicSelectMUI params={params} column={column}/>;
          } else if (column?.fieldType === 'address') {
            return <SingleSelectAddressMUI params={params} column={column}/>;
          } else {
            return <SingleSelectMUI params={params} column={column}/>;
          }
        };
        columnSettings['renderHeaderFilter'] = (params: any) => {
          return (
            <DataGridSelectFilter
              props={params}
              schema={column?.tempSchema}
              columnData={state.rows.map((row: any) => row[params.item.field])}
              onChange={(value: any) => {
                handleChangeHeaderFilter(column.id, value);
              }}
            />
          );
        };
        columnSettings['sortComparator'] = (v1: any, v2: any) => {

          if (!v1?.name) {
            v1 = {
              name: 'a'
            };
          }

          if (!v2?.name) {
            v2 = {
              name: 'a'
            };
          }

          if (v1?.name && v2?.name) {
            return v1.name.localeCompare(v2.name);
          }
          return 0;
        };
        columnSettings['filterOperators'] = [
          {
            label: 'equals',
            value: 'equals',
            getApplyFilterFn: (filterItem: any) => {
              if (
                !filterItem.field ||
                !filterItem.value ||
                !filterItem.operator
              ) {
                return null;
              }
              return (params: any): boolean => {
                return params?.value?.id === filterItem.value?.id;
              };
            },
            InputComponent: (params: any) => {
              const handleChange = (
                event: React.SyntheticEvent,
                newValue: any
              ) => {
                params.applyValue({...params.item, value: newValue});
              };

              const columnData = state.rows.map(
                (row: any) => row[params.item.field]
              );
              const flattenedData = columnData.flatMap((array: any) => array);

              const uniqueOptions = flattenedData
                .filter(
                  (value: any, index: any, self: any) =>
                    value?.id &&
                    value?.name &&
                    index === self.findIndex((v: any) => v?.id === value?.id)
                )
                .map((value: any) => ({
                  id: value.id,
                  name: value.name,
                  label: value.name,
                }));

              return (
                <>
                  <FormControl fullWidth>
                    <Autocomplete
                      sx={{
                        marginTop: '19px',
                      }}
                      size="small"
                      options={uniqueOptions || []}
                      getOptionLabel={(option: any) => option.name || ''}
                      isOptionEqualToValue={(option: any, value: any) =>
                        option.id === value.id
                      }
                      onChange={handleChange}
                      value={params.item.value || null}
                      renderInput={(paramsInput: any) => (
                        <TextField
                          {...paramsInput}
                          variant="standard"
                          placeholder="Select..."
                        />
                      )}
                    />
                  </FormControl>
                </>
              );
            },
          },
        ];

        /*columnSettings['filterOperators'] = [
          {
            label: 'equals',
            value: 'equals',
            getApplyFilterFn: (filterItem: any) => {
              if (
                !filterItem.field ||
                !filterItem.value ||
                !filterItem.operator
              ) {
                return null;
              }
              return (params: any): boolean => {
                return params?.value?.id === filterItem.value?.id;
              };
            },
          },
          {
            label: 'includes',
            value: 'includes',
            getApplyFilterFn: (filterItem: any) => {
              if (
                !filterItem.field ||
                !filterItem.value ||
                !filterItem.operator
              ) {
                return null;
              }
              return (params: any): boolean => {
                return params?.value?.id === filterItem.value?.id;
              };
            },
          },
        ];*/
        if (columnSettings['type'] === 'one-link') {
          columnSettings['renderCell'] = (params: any) => {
            return <LinkCell params={params} column={column}/>;
          };
        }
        if (!isAdmin && column?.editOnlyByAdmin) {
          columnSettings['editable'] = false;
        }
      }
      if (column?.multiSwitchboard) {
        columnSettings['renderCell'] = (params: any) => {

          if (
            params.value === 'choose-package' ||
            params.value === 'choose-staff' ||
            params.value === 'choose-vehicle' ||
            params.value === 'choose-driver'
          ) {
            return (
              <ButtonCell
                props={params}
                refreshData={() => {
                  fetchData();
                }}
              />
            );
          }

          if (params.value === 'open-reservations') {
            return <OpenReservationCell
              props={params}
              openReservation={() => {
                const sendData: any = {
                  name:
                    schema?.pluralName === 'Activity Reservations'
                      ? params?.row?.group?.name
                        ? `${params?.row?.group?.name} - ${params?.row?.activity?.name}`
                        : `${params?.row?.activity?.name}`
                      : params?.row?.name,
                };

                if (
                  schema?.pluralName === 'Activity Reservations'
                ) {
                  sendData.activity = params?.row?.activity;
                  sendData.activity_reservation = {
                    id: params?.row?.id,
                    name: params?.row?.activity?.name,
                  };
                  sendData.group = params?.row?.group;

                  if (params?.row?.is_group) {
                    sendData.activity.is_group = 1;
                  }
                }

                if (schema?.pluralName === 'Groups') {
                  sendData.group = {
                    id: params?.row?.id,
                    name: params?.row?.name,
                  };
                }

                setOpenedReservations(sendData);
              }}
            />;
          }

          if (column?.fieldType === 'guideReservation') {
            return <SetGuideReservationCell props={params}/>;
          }
          if (column?.fieldType === 'guide') {
            return <SetGuideCell props={params}/>;
          }
          if (column?.fieldType === 'accommodation') {
            return <MultipleRowsCell props={params} apiRef={apiRef}/>;
          }
          if (column?.fieldType === 'multiple-rows') {
            return <MultipleRowsSimpleCell props={params} apiRef={apiRef}/>;
          }
          if (column?.fieldType === 'accommodation-address') {
            return <AccommodationAddressesCell props={params}/>;
          }

          if (column?.fieldType === 'address-line') {
            return <SetAddressLineCell props={params}/>;
          }
          return <SetCell props={params}/>;
        };
        columnSettings['renderEditCell'] = (params: any) => {
          if (column?.fieldType === 'guideReservation') {
            return <MultiSelectGuideMUI params={params} column={column}/>;
          }

          return <MultiSelectMUI params={params} column={column}/>;
        };
        columnSettings['renderHeaderFilter'] = (params: any) => {
          return (
            <>
              <DataGridMultiSelectFilter
                props={params}
                schema={column?.tempSchema}
                columnData={state.rows.map(
                  (row: any) => row[params.item.field]
                )}
                onChange={(value: any) => {
                  handleChangeHeaderFilter(column.id, value);
                }}
              />
            </>
          );
        };
        /*columnSettings['filterOperators'] = [
          {
            label: 'equals',
            value: 'equals',
            getApplyFilterFn: (filterItem: any) => {
              if (
                !filterItem.field ||
                !filterItem.value ||
                !filterItem.operator
              ) {
                return null;
              }
              return (params: any): boolean => {
                // Ellenőrzi, hogy az elem szerepel-e a params.value tömbben
                return params.value?.some(
                  (item: any) => item?.id === filterItem.value?.id
                );
              };
            },
            InputComponent: (params: any) => {
              // params tartalmazza: item, applyValue, apiRef, stb.
              // Hozzuk létre a saját onChange függvényt, ami meghívja az applyValue-t:
              const handleChange = (value: any) => {
                // Ha az új érték beérkezett, alkalmazzuk azt:
                params.applyValue({...params.item, value});
              };

              console.log('jeeeeeeeeeeeeee');

              return (
                <DataGridMultiSelectFilter
                  props={params} // vagy ha inkább destruktúrálod: {...params}
                  schema={params.column?.tempSchema} // vagy az adott column schema, amire szükséged van
                  columnData={/!* Gyűjtsd össze a column adatokat, pl.: *!/ state.rows.map((row: any) => row[params.item.field])}
                  onChange={handleChange}
                />
              );
            }
          },
          {
            label: 'includes', // Új szűrő operátor
            value: 'includes', // Új szűrő operátor
            getApplyFilterFn: (filterItem: any) => {
              if (
                !filterItem.field ||
                !filterItem.value ||
                !filterItem.operator
              ) {
                return null;
              }
              return (params: any): boolean => {
                // Ellenőrzi, hogy az elem szerepel-e a params.value tömbben
                return params.value?.some(
                  (item: any) => item?.id === filterItem.value?.id
                );
              };
            },
            InputComponent: (props: any) => GridFilterInputValue,
          },
        ];*/

        columnSettings['filterOperators'] = [
          {
            label: 'contains',
            value: 'equals',
            getApplyFilterFn: (filterItem: any) => {
              if (
                !filterItem.field ||
                !filterItem.value ||
                !filterItem.operator
              ) {
                return null;
              }
              return (params: any): boolean => {
                return params.value?.some(
                  (item: any) => item?.id === filterItem.value?.id
                );
              };
            },
            InputComponent: (params: any) => {
              const handleChange = (
                event: React.SyntheticEvent,
                newValue: any
              ) => {
                params.applyValue({...params.item, value: newValue});
              };

              const columnData = state.rows.map(
                (row: any) => row[params.item.field]
              );
              const flattenedData = columnData.flatMap((array: any) => array);

              const uniqueOptions = flattenedData
                .filter(
                  (value: any, index: any, self: any) =>
                    value?.id &&
                    value?.name &&
                    index === self.findIndex((v: any) => v?.id === value?.id)
                )
                .map((value: any) => ({
                  id: value.id,
                  name: value.name,
                  label: value.name,
                }));

              return (
                <>
                  <FormControl fullWidth>
                    <Autocomplete
                      sx={{
                        marginTop: '19px',
                      }}
                      size="small"
                      options={uniqueOptions || []}
                      getOptionLabel={(option: any) => option.name || ''}
                      isOptionEqualToValue={(option: any, value: any) =>
                        option.id === value.id
                      }
                      onChange={handleChange}
                      value={params.item.value || null}
                      renderInput={(paramsInput: any) => (
                        <TextField
                          {...paramsInput}
                          variant="standard"
                          placeholder="Select..."
                        />
                      )}
                    />
                  </FormControl>
                </>
              );
            },
          },
        ];
      }
      if (columnSettings['type'] === 'guideReservation') {
        columnSettings['renderHeaderFilter'] = (params: any) => {
          return (
            <>
              <DataGridGuideMultiSelectFilter
                props={params}
                schema={column?.tempSchema}
                columnData={state.rows.map(
                  (row: any) => row[params.item.field]
                )}
                onChange={(value: any) => {
                  handleChangeHeaderFilter(column.id, value);
                }}
              />
            </>
          );
        };
        columnSettings['filterOperators'] = [
          {
            value: 'equals',
            getApplyFilterFn: (filterItem: any) => {
              if (
                !filterItem.field ||
                !filterItem.value ||
                !filterItem.operator
              ) {
                return null;
              }
              return (params: any): boolean => {
                // Ellenőrzi, hogy az elem szerepel-e a params.value tömbben
                return params.value?.some(
                  (item: any) => item?.guide?.id === filterItem.value?.id
                );
              };
            },
          },
          {
            value: 'includes', // Új szűrő operátor
            getApplyFilterFn: (filterItem: any) => {
              if (
                !filterItem.field ||
                !filterItem.value ||
                !filterItem.operator
              ) {
                return null;
              }
              return (params: any): boolean => {
                // Ellenőrzi, hogy az elem szerepel-e a params.value tömbben
                return params.value?.some(
                  (item: any) => item?.guide?.id === filterItem.value?.id
                );
              };
            },
          },
        ];

        columnSettings['sortComparator'] = (a: any, b: any) => {
          const nameA = a?.[0]?.guide?.name?.toLowerCase() ?? '';
          const nameB = b?.[0]?.guide?.name?.toLowerCase() ?? '';
          return nameA.localeCompare(nameB);
        };

      }
      if (columnSettings['field'] === 'original_cost') {
        columnSettings['align'] = 'right';
        columnSettings['headerAlign'] = 'right';
      }
      /*if (columnSettings['type'] === 'boolean') {
        columnSettings['renderCell'] = (params: any) => {
          if (params?.id === 'SUM') {
            return (
              <></>
            );
          }
        };
      }*/

      columnSettings['renderHeader'] = (params: any) => {
        return (
          <Typography
            variant={'body2'}
            sx={{
              width: '100%',
              fontWeight: 'bold',
            }}
            onContextMenu={(event) => {
              event.preventDefault();
              apiRef.current.showColumnMenu(params.field);
            }}
          >
            {params.colDef.headerName}
          </Typography>
        );
      };
      columnSettings['minWidth'] = 60;

      if (
        column.name.length < 2 ||
        (column?.url &&
          column.url.includes('/status') &&
          column.url.includes('/statuses'))
      ) {
        columnSettings['minWidth'] = 35;
      }

      if (column?.readOnly) {
        columnSettings['editable'] = false;
      }
      columnArray[columnIndex + 1] = columnSettings;

      return true;
    });
    return Object.values(columnArray);
  }, [
    schema,
    checkedRows,
    rowModesModel,
    openHeaderFilters,
    visibleColumns,
    visibleRows,
    state.rows,
    sortModelStatic,
    filterModelStatic,
    paginationModelStatic,
    apiRef,
  ]);

  const schemaMemo = useMemo(() => {
    return schema;
  }, [schema]);

  const sortedColumns = useMemo(() => {
    const tempColumns = [...columns];

    return tempColumns.sort((a: any, b: any) => {
      return a.headerName.localeCompare(b.id);
    });
  }, [columns]);

  const datagridHeight = useMemo(() => {
    let height = 45;
    if (schema?.filters) {
      height += 50;
    }
    if (schema?.name === 'Service Reservations View') {
      height += 70;
    }

    let selectedFilterValue = 0;
    Object.keys(fastFilterValue).map((index) => {
      if (fastFilterValue[index]?.selected) {
        selectedFilterValue = 1;
      }
    });

    if (selectedFilterValue) {
      height += 50;
    }

    if (reservationDialog) {
      height = 300;
    }

    if (
      schema?.viewTable === 'groups' ||
      schema?.viewTable === 'activity_reservations'
    ) {
      return `calc(100% - ${height}px)`;
    }

    return `calc(100vh - ${height}px)`;
  }, [schema, fastFilterValue, reservationDialog]);

  const reorderColumns = ColumnReorderHandler({
    apiRef,
    viewId,
    subViewId,
    schema,
    visibleColumns,
    setVisibleColumns,
  });

  const {viewPeriod, viewAgent} = useStateContext();

  const searchParamsCopy = useMemo(() => {
    const searchParams = new URLSearchParams();
    if (viewPeriod[0]) {
      searchParams.append('from', toISODateString(viewPeriod[0]));
    }
    if (viewPeriod[1]) {
      searchParams.append('to', toISODateString(viewPeriod[1]));
    }
    if (viewAgent && viewAgent?.id !== undefined) {
      searchParams.append('booking_agent', viewAgent?.id);
    }
    return searchParams;
  }, [viewPeriod, viewAgent]);

  const latestRequestId = useRef(0);

  const fetchData = useCallback(() => {
    const currentRequestId = ++latestRequestId.current; // Verziószám növelése

    const rowModesModelTemp = {...rowModesModel};
    Object.keys(rowModesModelTemp).forEach((rowId) => {
      if (rowModesModelTemp[rowId].mode === GridRowModes.Edit) {
        rowModesModelTemp[rowId] = {
          mode: GridRowModes.View,
          ignoreModifications: false,
        };
      }
    });
    setRowModesModel(rowModesModelTemp);

    setState((prevState: any) => ({
      ...prevState,
      isLoading: true,
    }));

    const filterOptions: any = {};
    filterModel.items.map((item: any) => {
      if (item?.field && item?.value) {
        filterOptions[item?.field] = {
          0: item?.value,
        };
      }
    });

    const fastFilterValueTemp = {...fastFilterValueServiceProvider};

    if (reservationDialog) {
      fastFilterValueTemp.group = {
        id: reservationDialog?.group?.id,
        name: reservationDialog?.group?.name,
      };
      fastFilterValueTemp.activity = {
        id: reservationDialog?.activity?.id,
        name: reservationDialog?.activity?.name,
      };
    }

    searchParamsCopy.set('fast_search', fastSearchValue);
    searchParamsCopy.set(
      'fast_filter_options',
      JSON.stringify(fastFilterValueTemp)
    );
    searchParamsCopy.set('has_filters', (!!reservationDialog).toString());
    searchParamsCopy.set('show_deleted', showDeleted.toString());
    searchParamsCopy.set(
      'filter_prices',
      filterOriginalAndFinalPrice.toString()
    );

    const promise = selectedGroupId
      ? schema.name === 'Crazy Booking'
        ? api.get(
          `/crazy-groups/${selectedGroupId?.id}/bookings`,
          searchParamsCopy
        )
        : api.get(
          `/groups/${selectedGroupId?.id}/activity-reservations`,
          searchParamsCopy
        )
      : schema.client.readAll(
        paginationModel.page + 1,
        searchParamsCopy,
        paginationModel.pageSize.toString(),
        filterOptions,
        sortModel
      );

    promise
      .then((res: any) => {
        if (currentRequestId !== latestRequestId.current) {
          console.log(`Skip request response: ${schema.name}`);
          return;
        }

        const tempRes = res?.data ? res.data : res;

        ReactDOM.flushSync(() => {
          setState({
            rows: tempRes,
            rowCount: tempRes.length,
            isLoading: false,
            loadedRows: true,
          });
          if (apiRef?.current) {
            apiRef.current.updateRows(tempRes);
          }
        });

        if (!isView && apiRef?.current) {
          const selectedRows = apiRef.current.getSelectedRows();
          const array = [...selectedRows];

          let issetRow = false;

          if (selectedRowId) {
            const refreshedSelectedRowData: any = res.find((row: any) => {
              return row?.id === selectedRowId?.id;
            });
            if (refreshedSelectedRowData) {
              issetRow = true;
            }
            onRowSelected(refreshedSelectedRowData);
          }

          array.map(([key, value]) => {
            apiRef?.current.selectRow(key, issetRow);
          });
        }

        if (selectedRowId) {
          const refreshedSelectedRowData: any = res.find((row: any) => {
            return row?.id === selectedRowId?.id;
          });
          onRowSelected(refreshedSelectedRowData);
        }
      })
      .then(() => sleep(0))
      .then(() => {
        if (currentRequestId !== latestRequestId.current) {
          return;
        }
        if (apiRef?.current) {
          apiRef.current.autosizeColumns(autosizeOptions);
        }
      })
      .catch((e) => {
        console.log(e);
      });

    // Call progress percent api
    if (schema?.name === 'Service Reservations View') {
      api
        .get('/service-reservations/get-progress-percent', searchParamsCopy)
        .then((res: any) => {
          setProgressPercent(res);
        })
        .catch(() => {
          toast.error('Failed to load the Confirmed ratio percentage');
        });
    } else {
      setProgressPercent(null);
    }
  }, [
    firstLoad,
    schema,
    viewPeriod,
    apiRef,
    paginationModel,
    searchParamsCopy,
    sortModel,
    selectedRowId,
    fastSearchValue,
    reservationDialog,
    fastFilterValueServiceProvider,
    visibleColumns,
    filterModel,
    selectedGroupId,
    showDeleted,
    filterOriginalAndFinalPrice,
    rowModesModel,
  ]);

  const [closingEditDone, setClosingEditDone] = useState(false);

  const closeAllEditRows = () => {
    const updated = {...rowModesModel};

    const hasActiveEditRow = Object.values(updated).some(
      (row: any) => row.mode === GridRowModes.Edit
    );

    if (!hasActiveEditRow) {
      return;
    }

    let changed = false;

    Object.keys(updated).forEach((rowId) => {
      if (updated[rowId]?.mode === GridRowModes.Edit) {
        updated[rowId] = {
          mode: GridRowModes.View,
          ignoreModifications: false,
        };
        changed = true;
      }
    });

    if (changed) {
      setRowModesModel(updated);
      setClosingEditDone(true);
    } else {
      fetchData();
    }
  };

  useEffect((): any => {
    if (closingEditDone) {
      const timer = setTimeout(() => {
        fetchData();
        setClosingEditDone(false);
      }, 0);

      return () => clearTimeout(timer);
    }
    return () => true;
  }, [closingEditDone, fetchData]);

  const fillOptionSend = useCallback(
    (type: string) => {
      if (selectedGroupId && selectedGroupId.id) {
        setState((prevState: any) => ({
          ...prevState,
          isLoading: true,
        }));

        schema.client
          .updateOption(selectedGroupId.id as number, {
            type: type,
          })
          .then((savedRow: any) => {
            fetchData();
          });
      }
    },
    [schema.client, selectedGroupId]
  );
  const fillOptionActivityReservationSend = useCallback(
    (row: any, type: string) => {
      setState((prevState: any) => ({
        ...prevState,
        isLoading: true,
      }));

      api
        .post(
          `/activity-reservations/update-group-size/reservation/${row?.id}`,
          {
            type: type,
          }
        )
        .then((savedRow: any) => {
          fetchData();
        });
    },
    [schema.client, selectedGroupId]
  );

  const loadFastFilters = useCallback(() => {
    const fastFilterValueTemp: any = {};
    setFastFilters([]);

    const promises = Object.keys(schema.filters).map((column, index) => {
      fastFilterValueTemp[`${index}`] = {
        selected: 0,
        column: column,
      };

      const tempFilter: any = schema.filters[column];
      const searchParamsForFilter = new URLSearchParams();

      return tempFilter.schema.client
        .readAll(0, searchParamsForFilter)
        .then((res: any) => ({
          index,
          name: tempFilter.name,
          column,
          wait: tempFilter?.wait,
          data: res.data,
        }));
    });

    Promise.all(promises).then((results: any) => {
      const tempFastFilters: any = [...fastFilters];
      results.forEach(
        ({
           index,
           name,
           column,
           wait,
           data,
         }: {
          index: any;
          name: any;
          column: any;
          wait: any;
          data: any;
        }) => {
          tempFastFilters[index] = {
            name,
            column,
            wait,
            data,
          };
        }
      );
      setFastFilters(tempFastFilters);
      setFastFilterValue(fastFilterValueTemp);
    });
  }, [fastFilterValue, fastFilters, schema]);

  /* Callbacks END */

  /* Effects */

  useEffect(() => {
    const refreshData = (updatedRows: any = null) => {
      if (updatedRows && Array.isArray(updatedRows)) {
        setState((prevState: any) => ({
          ...prevState,
          rows: prevState.rows.map((row: any) => {
            const updated = updatedRows.find((r: any) => r.id === row.id);
            return updated ? {...row, ...updated} : row;
          }),
        }));
      } else {
        fetchData(); // teljes újratöltés
      }
    };

    if (setFunctionRef) {
      setFunctionRef(refreshData);
    }
  }, [setFunctionRef, fetchData]);

  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      prevSchema.client
        .deleteLock(0, {
          schema: JSON.stringify(prevSchema.client),
          view_table: prevSchema.viewTable,
        })
        .then((result: any) => {
        });
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    const debouncedFetch = debounce(() => {
      fetchData();
    }, 200);

    debouncedFetch();
    return () => {
      debouncedFetch.cancel();
    };
  }, [
    newEntityFixedValues,
    searchParamsCopy,
    sortModel,
    fastSearchValue,
    fastFilterValueServiceProvider,
    filterModel,
    selectedGroupId,
    showDeleted,
    filterOriginalAndFinalPrice,
  ]);

  useEffect(() => {
    if (reservationDialog) {
      const fastFilterValueTemp = {...fastFilterValueServiceProvider};
      fastFilterValueTemp.group = reservationDialog?.group;
      fastFilterValueTemp.activity = reservationDialog?.activity;
      if (reservationDialog?.activity_reservation) {
        fastFilterValueTemp.activity_reservation = reservationDialog?.activity_reservation;
      }

      setFastFilterValueServiceProvider(fastFilterValueTemp);
      if (reservationDialog?.ids) {
        setHighlightedRows(reservationDialog?.ids);
      }
    }
  }, [reservationDialog]);

  useEffect(() => {
    // TODO: this causes problem when url has :id
    handleCloseSlidingPane();

    setFastSearchValue('');
    initializeSchemaState();
  }, [schemaMemo]);

  /* Effects END */

  /* Handles */

  const initializeSchemaState = () => {
    setPrevSchema(schema);
    setFirstLoad(true);

    if (schema?.filters) {
      loadFastFilters();
    } else {
      setFastFilters([]);
    }

    setSortModel([]);
  };

  const handleSaveClick = (id: GridRowIdType) => () => {
    setRowModesModel({...rowModesModel, [id]: {mode: GridRowModes.View}});
  };

  const duplicateHandleClick = async (duplicatedRowId: any, schema: any) => {
    schema.client
      .duplicate(duplicatedRowId)
      .then((result: any) => {
        fetchData();

        toaster.show({
          intent: 'success',
          message: `Successfully duplicated ${schema.name} ID ${duplicatedRowId}`,
        });
      })
      .catch((error: any) => {
        let array: any = [];
        for (let errorKey in error) {
          for (let errorMsg in error[errorKey]) {
            array.push(`${errorKey}: ${error[errorKey][errorMsg]}`);
          }
        }
        toaster.show({
          message: (
            <>
              <span>Error saving {schema.name}</span>
              <pre>{array.join('\n')}</pre>
            </>
          ),
          intent: 'danger',
        });
      });
  };

  const restoreHandleClick = async (duplicatedRowId: any, schema: any) => {
    schema.client
      .restore(duplicatedRowId)
      .then((result: any) => {
        fetchData();

        toast.success(
          `Successfully restored ${schema.name} ID ${duplicatedRowId}`
        );
      })
      .catch((error: any) => {
        toast.error(error?.message);
      });
  };


  const handleCancelClick = (id: any) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: {mode: GridRowModes.View, ignoreModifications: true},
    });

    const rowData = apiRef.current.getRow(id);

    schema.client.deleteLock(rowData?.id, {
      schema: JSON.stringify(schema.client),
      view_table: schema.viewTable,
    });
  };

  const handleCheckRowLockStatus = useCallback(
    (id: number) => {
      const matchedRow = lockedRows.find((row: any) => row.relation_id == id);

      return {
        locked: !!matchedRow,
        row: matchedRow || null,
      };
    },
    [lockedRows, schema]
  );

  async function generateClipboardData(row: any) {
    try {
      // 🔁 Több kérés egyenként minden sorra (async/await párhuzamosítás)
      const responses = await Promise.all(
        rowSelectionModel.map((row:any) =>
          api.get(`/service-reservations/generate-clipboard-data/${row}`)
        )
      );

      // 🔗 Összefűzzük a válaszokat, sortöréssel
      const combined = responses.map(res => res.trim()).join('\n\n');

      // 📋 Másolás a vágólapra
      await navigator.clipboard.writeText(combined);

      return combined;
    } catch (error) {
      throw error;
    }
  }

  const handleGenerateClipboardData = async (row: any) => {
    toast.promise(generateClipboardData(row), {
      loading: 'Generating clipboard data...',
      success: <b>Copied to clipboard!</b>,
      error: <b>Error while generating data</b>,
    });
  };

  const handleColumnPinned = (pinned: any, details: any) => {
    setPinnedColumns(pinned);

    const id = viewId ? viewId : subViewId;

    if (id !== undefined) {
      const updatedView = api.patch(`/views/${id}`, {
        pins: pinned,
      });
    }
  };

  function CustomUserItem(props: any) {
    return (
      <>
        <MenuItem
          onClick={(event) => {
            setPopupState(true);
            props.onClick(event);
          }}
        >
          <ListItemIcon>
            <ViewWeekIcon fontSize={'small'}/>
          </ListItemIcon>
          <ListItemText>Manage Columns</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={(event) => {
            setVisibleColumns({
              ...visibleColumns,
              [`${props?.colDef?.field}`]: false,
            });
          }}
        >
          <ListItemIcon>
            <VisibilityOffIcon fontSize={'small'}/>
          </ListItemIcon>
          <ListItemText>Hide Column</ListItemText>
        </MenuItem>
      </>
    );
  }

  function CustomColumnMenu(props: any) {
    return (
      <React.Fragment>
        <GridColumnMenu
          {...props}
          slots={{
            columnMenuSortItem: GridColumnMenuSortItem,
            columnMenuFilterItem: GridColumnMenuFilterItem,
            columnMenuPinningItem: GridColumnMenuPinningItem,
            columnMenuColumnsItem: null,
            columnMenuUserItem: CustomUserItem,
          }}
        />
      </React.Fragment>
    );
  }

  const [openFilters, setOpenFilters] = useState(!isMobile);

  const CustomFooter = () => {
    return (
      <></>
      /*<Stack
        direction={'row'}
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 8px',
        }}
      >

        <GridFooter/>
      </Stack>*/
    );
  };

  const handleCloseSlidingPane = (value?: any) => {
    if (setCurrentEditedRow) {
      setCurrentEditedRow(undefined, true);
    }
    if (!value) {
      return;
    }
    schema.client.deleteLock(value?.id, {
      schema: JSON.stringify(schema.client),
      view_table: schema.viewTable,
    });
  };

  /* Handles END*/

  const handleChangeFastFilter = (
    newValue: number,
    index: number,
    column: any,
    data: any
  ) => {
    setFastFilterValue({
      ...fastFilterValue,
      [`${index}`]: {
        selected: newValue,
        column: column?.column,
      },
    });
    const currentFilterModel = {...filterModel};
    let founded = 0;

    const newFilterModel = currentFilterModel.items.map(
      (item: any, index: number) => {
        if (item.field === column.column) {
          item.value = data;
          founded = 1;
        }
        return item;
      }
    );

    if (!founded) {
      newFilterModel.push({
        field: column.column,
        id: 1,
        operator: 'equals',
        value: data,
      });
    }
    setFilterModel({...filterModel, ['items']: newFilterModel});
  };

  const handleChangeHeaderFilter = (column: string, value: any) => {
    const getDefaultFilter = (field: string) => ({field, operator: 'equals'});

    const state = apiRef.current.state;
    const filterModel = gridFilterModelSelector(state);

    const currentFieldFilters = filterModel.items?.filter(
      ({field}) => field === column
    );

    if (!value) {
      if (currentFieldFilters[0]) {
        apiRef.current.deleteFilterItem(currentFieldFilters[0]);
      }
    } else {
      apiRef.current.upsertFilterItem({
        ...(currentFieldFilters[0] || getDefaultFilter(column)),
        value: value,
      });
    }
  };

  const handleDownloadMasterSettlementRiport = async () => {
    setMasterSettlementRiportLoading(true);

    try {
      const response: any = await api
        .get('/groups/master-settlement-riport', searchParams)
        .catch((error) => {
          console.error('Hiba történt az API hívás során:', error);
          throw error;
        });

      const data = {
        headers: [
          {
            header: 'Activity',
            key: 'activity',
            width: 15,
          },
          {
            header: 'Group',
            key: 'group',
            width: 15,
          },
          {
            header: 'Service provider',
            key: 'service_provider',
            width: 11,
          },
          {
            header: 'Guide',
            key: 'guide',
            width: 13,
          },
          {
            header: 'Group size',
            key: 'group_size',
            align: 'right',
            width: 4,
          },
          {
            header: 'Date',
            key: 'date',
            align: 'right',
            width: 8,
          },
        ],
        rows: response,
        dates: {
          from: searchParams?.get('from'),
          to: searchParams?.get('to'),
        },
      };

      // XLS fájl generálásának megvárása
      await generateXLSFile(data);

      console.log('A fájl sikeresen létrejött!');
    } catch (error) {
      console.error('Hiba történt a fájl generálása során:', error);
    } finally {
      setMasterSettlementRiportLoading(false);
    }
  };

  const clickTimeoutRef = useRef<ReturnType<typeof setTimeout>>();

  const handleRowClick = (params: any, event: any, details: any) => {
    clearTimeout(clickTimeoutRef.current);

    const isAlreadySelected = apiRef?.current.isRowSelected(params.id);
    const rowMode = apiRef.current.getRowMode(params.id);

    setContextMenu(null);

    if (!isAlreadySelected && rowMode !== 'edit') {
      if (openedPanel) {
        if (setCurrentEditedRow) {
          setCurrentEditedRow(params?.row);
        }

        if (schema.hasCheckField) {
          setRowSelectionModel([params?.row.id]);
        }
      } else {
        if (setCurrentEditedRow && currentEditedRow?.row?.id) {
          setCurrentEditedRow(undefined);
        }
      }

      const rowModesModelTemp = {...rowModesModel};

      Object.keys(rowModesModelTemp).forEach((rowId) => {
        if (rowModesModelTemp[rowId].mode === GridRowModes.Edit) {
          rowModesModelTemp[rowId] = {
            mode: GridRowModes.View,
            ignoreModifications: false,
          };
        }
      });

      setRowModesModel(rowModesModelTemp);

      onRowSelected(params?.row);
    }
  };

  const handleRowDoubleClick = (params: any) => {
    const isActivityReservation = schema.name === 'Activity Reservation';

    if (!isActivityReservation && params.row?.is_group_item) {
      toast.error('This is a display-only field and cannot be edited');
    } else {
      const rowModesModelTemp = {...rowModesModel};
      Object.keys(rowModesModelTemp).forEach((rowId) => {
        if (rowModesModelTemp[rowId].mode === GridRowModes.Edit) {
          rowModesModelTemp[rowId] = {
            mode: GridRowModes.View,
            ignoreModifications: false,
          };
        }
      });
      if (!params?.row?.id) {
        return toast.error('Row id not found');
      }

      // Check locked rows

      const isRowUnderEdit: any = handleCheckRowLockStatus(params.row.id);

      if (isRowUnderEdit.locked) {
        if (isRowUnderEdit.row?.user?.id !== user?.id) {
          toast.error(
            <>
              <p>
                This row is already under edit by:{' '}
                <b>{isRowUnderEdit?.row?.user?.name}</b>
              </p>
            </>
          );
        }
      } else {
        setRowModesModel({
          ...rowModesModelTemp,
          [params.id]: {
            mode: GridRowModes.Edit,
          },
        });

        schema.client.lock(params?.row?.id, {
          schema: JSON.stringify(schema.client),
          view_table: schema.viewTable,
        });

        if (schema.name === 'Service Reservations View') {
          api
            .post(`/notifications/service-reservation/${params?.row?.id}`, {})
            .then((result: any) => {
              setState((prevState: any) => ({
                ...prevState,
                rows: prevState.rows.map((row: any) =>
                  row.id === params?.row?.id
                    ? {...row, notification_count: false}
                    : row
                ),
              }));
            });
        }
      }
    }
    return true;
  };

  const getTreeDataPath: DataGridProPropsType['getTreeDataPath'] = (
    row: any
  ) => {
    return row?.hierarchy ? row.hierarchy : [];
  };

  const [expandedRows, setExpandedRows] = useState<Set<string>>(new Set());

  function CustomGridTreeDataGroupingCell(props: any) {
    const {id, field, rowNode} = props;
    const filteredDescendantCountLookup = useGridSelector(
      apiRef,
      gridFilteredDescendantCountLookupSelector
    );
    const filteredDescendantCount =
      filteredDescendantCountLookup[rowNode.id] ?? 0;

    const handleClick = (event: any) => {
      if (rowNode.type !== 'group') {
        return;
      }

      const newExpandedRows = new Set(expandedRows);

      if (rowNode.childrenExpanded) {
        newExpandedRows.delete(id);
      } else {
        newExpandedRows.add(id);
      }
      setExpandedRows(newExpandedRows);
      apiRef.current.setRowChildrenExpansion(id, !rowNode.childrenExpanded);
      apiRef.current.setCellFocus(id, field);
      event.stopPropagation();
    };

    const divRef = useRef(null);
    const [tooltip, setTooltip] = useState(false);

    /*function getDivWidth(divRef: any) {
      if (divRef && divRef.current) {
        const divElement = divRef.current;
        const parentElement = divElement.parentNode;
        if (
          props?.field === 'accommodation' &&
          props?.row?.accommodation_color
        ) {
          parentElement.style.background = props?.row?.accommodation_color;
        }

        const divRect = divElement.getBoundingClientRect();
        const parentRect = parentElement.getBoundingClientRect();

        return {
          element: divRect.width,
          cell: parentRect.width,
        };
      }
      return {
        element: 0,
        cell: 0,
      };
    }*/

    /* useEffect(() => {
      setTooltip(false);
      const divWidth: { element: number; cell: number } = getDivWidth(divRef);

      if (divWidth['element'] > divWidth['cell']) {
        setTooltip(true);
      }
    });*/
    const checkForOverflow = () => {
      if (divRef.current) {
        const element: any = divRef.current;
        return element.scrollWidth > element.clientWidth;
      }
      return false;
    };

    useEffect(() => {
      setTooltip(checkForOverflow());
    });

    useEffect(() => {
      if (expandedRows.has(id)) {
        apiRef.current.setRowChildrenExpansion(id, true);
      }
    }, [expandedRows, id, apiRef]);

    return (
      <>
        <Stack
          ref={divRef}
          direction={'row'}
          alignItems={'center'}
          className={`whitespace-break-spaces ${
            tooltip ? 'has-tooltip' : 'doesnthave-tooltip'
          }`}
        >
          {filteredDescendantCount > 0 ? (
            <>
              {/* {expandedRows.has(id) ? (
                <IconButton onClick={handleClick} tabIndex={-1}>
                  <ExpandMoreRoundedIcon />
                </IconButton>
              ) : (
                <IconButton onClick={handleClick} tabIndex={-1}>
                  <ChevronRightRoundedIcon />
                </IconButton>
              )}*/}
              {`(${filteredDescendantCount}) `}
            </>
          ) : (
            <span/>
          )}

          {tooltip ? (
            <>
              <Tooltip
                disableInteractive
                title={
                  typeof props?.value === 'object' && props?.value !== null
                    ? '-----'
                    : props?.value
                }
                slotProps={{
                  tooltip: {
                    sx: {
                      fontSize: '13px',
                    },
                  },
                  popper: {
                    modifiers: [
                      {
                        name: 'offset',
                        options: {
                          offset: [0, -14],
                        },
                      },
                    ],
                  },
                }}
              >
                <Box>
                  {typeof props?.value === 'object' && props?.value !== null
                    ? '-'
                    : props?.value}
                </Box>
              </Tooltip>
            </>
          ) : (
            <>
              <Box>
                {typeof props?.value === 'object' && props?.value !== null
                  ? '-'
                  : props?.value}
              </Box>
            </>
          )}
        </Stack>
      </>
    );
  }

  const getRowHeight = useCallback(
    (params: any) => {

      const defaultHeight = {
        normal: 22,
        slim: 16
      };

      if (params?.id === 'SUM') {
      }

      if (schema.name === 'Group') {
        if (!params.model?.guides) {
          return 22;
        }
        const cellValue = params.model.guides;
        const accommodationCellValue = params.model?.accommodation_names ? params.model?.accommodation_names : [];

        const findGuide = params.model?.find_guide;

        // Ha findGuide true, akkor +1-et hozzáadunk a cellValue hosszához
        let adjustedGuideCount = cellValue.length + (findGuide ? 1 : 0);

        if (adjustedGuideCount < 2 && accommodationCellValue.length < 2) {
          return 22;
        }

        const maxLength = Math.max(
          adjustedGuideCount,
          accommodationCellValue.length
        );

        return defaultHeight.slim * (maxLength ? maxLength : 1);
      }

      if (schema.name === 'Activity Reservation') {
        const guideReservations = params.model?.guide_reservations || [];
        const staff = params.model?.staff !== 'open-reservations' ? (params.model?.staff || []) : [];

        const guideLength = guideReservations.length;
        const staffLength = staff.length;

        const maxLength = Math.max(guideLength, staffLength);

        if (maxLength < 2) {
          return defaultHeight.normal;
        }

        return defaultHeight.slim * maxLength;
      }
      return defaultHeight.normal;
    },
    [state?.rows]
  );

  const mutateRow = useFakeMutation();
  const [pendingRowUpdate, setPendingRowUpdate] = useState<{
    resolve: Function;
    newRow: any;
    oldRow: any;
    type: 'time' | 'status' | 'sp_status'
  } | null>(null);

  const handleConfirm = async (confirmed: boolean) => {
    if (pendingRowUpdate) {
      const {resolve, newRow, oldRow} = pendingRowUpdate;
      setPendingRowUpdate(null);

      if (confirmed) {
        // Folytatjuk a sor frissítését
        /* const { updatedRow, failedFieldsArray } = await mutateRow(
           newRow,
           oldRow,
           schema
         );*/

        // Fire and forget
        (async () => {
          try {
            const {updatedRow, failedFieldsArray, updatedRows} = await mutateRow(
              newRow,
              oldRow,
              schema
            );

            if (schema.name === 'Activity Reservation') {
              if (
                (newRow?.final_price !== oldRow?.final_price ||
                newRow?.final_price_pp !== oldRow?.final_price_pp)
                ||
                (newRow?.group_size !== oldRow?.group_size)
              ) {
                fetchData();
              }
            }

            if (schema.name === 'Service Reservations View') {
              if (
                newRow?.date ||
                newRow?.start_time || // Ha módosították és az Igen lett kiválasztva, akkor lefut
                newRow?.pickup_time ||
                newRow?.meeting_place ||
                newRow?.venue ||
                newRow?.service_reservation_type
              ) {
                setState((prevState: any) => ({
                  ...prevState,
                  rows: prevState.rows.map((row: any) => {
                    const updated = updatedRows.find((r: any) => r.id === row.id);
                    return updated ? {...row, ...updated} : row;
                  }),
                }));
              }
            }

            Object.keys(failedFieldsArray).map((field: any) => {
              const failedData = failedFieldsArray[field];
              failedData.map((failed: any) => {
                toast.error(failed);
              });
            });

            let message = Object.keys(failedFieldsArray).length
              ? 'Successfully saved data, but some fields failed to save'
              : 'Successfully saved data';

            if (!isAdmin && schema?.viewTable === 'service_reservations' && newRow?.service_reservation_status?.id !== oldRow?.service_reservation_status?.id) {
              message = 'Status change request';
            }

            toast.success(message);
          } catch (err) {
            toast.error('Error saving data');
            console.error(err);
          }
        })();

        schema.client.deleteLock(oldRow.id, {
          schema: JSON.stringify(schema.client),
          view_table: schema.viewTable,
        });


        /* Object.keys(failedFieldsArray).forEach((field: any) => {
           const failedData = failedFieldsArray[field];
           failedData.forEach((failed: any) => {
             toast.error(failed);
           });
         });

         const message = Object.keys(failedFieldsArray).length
           ? 'Successfully saved data, but some fields failed to save'
           : 'Successfully saved data';

         toast.success(message);*/

        resolve(newRow);
      } else {
        resolve(oldRow);
      }
    }
  };

  const processRowUpdate = useCallback(
    async (newRow: any, oldRow: any) => {
      if (newRow?.start_time !== oldRow?.start_time) {
        return new Promise((resolve) => {
          setPendingRowUpdate({resolve, newRow, oldRow, type: 'time'});
        });
      }
      if (schema?.viewTable === 'service_reservations' && newRow?.service_reservation_status?.id !== oldRow?.service_reservation_status?.id && newRow?.service_reservation_status?.id === 6) {
        return new Promise((resolve) => {
          setPendingRowUpdate({resolve, newRow, oldRow, type: 'status'});
        });
      }

      if (schema?.viewTable === 'groups' && newRow?.status?.id !== oldRow?.status?.id) {
        return new Promise((resolve) => {
          setPendingRowUpdate({resolve, newRow, oldRow, type: 'sp_status'});
        });
      }

      // Fire and forget
      await toast.promise(
        (async () => {
          const {updatedRow, failedFieldsArray, updatedRows} = await mutateRow(
            newRow,
            oldRow,
            schema
          );

          Object.keys(failedFieldsArray).map((field: any) => {
            const failedData = failedFieldsArray[field];
            failedData.map((failed: any) => {
              toast.error(failed);
            });
          });

          let message = Object.keys(failedFieldsArray).length
            ? 'Successfully saved data, but some fields failed to save'
            : 'Successfully saved data';

          if (schema.name === 'Activity Reservation') {
            if (
              (newRow?.final_price !== oldRow?.final_price ||
                newRow?.final_price_pp !== oldRow?.final_price_pp)
              ||
              (newRow?.group_size !== oldRow?.group_size)
            ) {
              fetchData();
            }
          }

          if (schema.name === 'Service Reservations View') {
            if (
              newRow?.date ||
              newRow?.start_time ||
              newRow?.pickup_time ||
              newRow?.meeting_place ||
              newRow?.venue ||
              newRow?.service_reservation_type
            ) {
              if (updatedRows && updatedRows?.length) {
                setState((prevState: any) => ({
                  ...prevState,
                  rows: prevState.rows.map((row: any) => {
                    const updated = updatedRows.find((r: any) => r.id === row.id);
                    return updated ? {...row, ...updated} : row;
                  }),
                }));
              }
            }
          }

          if (schema?.viewTable === 'service_reservations' && newRow?.service_reservation_status?.id !== oldRow?.service_reservation_status?.id) {
            message = 'Status change request';
          }
          return message;
        })(),
        {
          loading: 'Saving data...',
          success: (msg: any) => msg,
          error: 'Error while saving data: 326',
        }
      );

      schema.client.deleteLock(oldRow.id, {
        schema: JSON.stringify(schema.client),
        view_table: schema.viewTable,
      });

      return newRow;
    },
    [mutateRow, fetchData, isAdmin]
  );

  const handleRowContextMenu = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();

    if (!event.currentTarget) {
      return;
    }
    const rowId = Number(
      (event.currentTarget as HTMLDivElement).getAttribute('data-id')
    );

    const record = state.rows.find((row: any) => {
      if (!row.row_number) {
        return row.id === rowId;
      }

      return row.row_number === rowId;
    });
    if (!record) {
      toast.error(`Error: could not get data for row: ${rowId}`);
      return;
    }

    const rowData = apiRef.current.getRow(rowId);

    setContextMenu(null);
    onRowSelected(record);
    if (!schema?.hasCheckField) {
      setRowSelectionModel([rowId]);
    } else {
      setRowSelectionModel((prevSelection: any) => {
        return prevSelection.includes(rowId)
          ? prevSelection
          : [...prevSelection, rowId];
      });
    }

    if (rowModesModel[rowId]?.mode !== 'edit') {
      setRightClickedRow(rowData);
      setContextMenu(
        contextMenu === null
          ? {mouseX: event.clientX + 2, mouseY: event.clientY - 6}
          : null
      );
    }
  };

  const handleProcessRowUpdateError = useCallback((error: any) => {
    toast.error(error.message);
  }, []);

  const exitEditMode = (id: any) => {
    setRowModesModel((prev: any) => ({
      ...prev,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    }));

    // opcionális: vedd le a lockot is
    const rowData = apiRef.current.getRow(id);
    if (rowData?.id) {
      schema.client.deleteLock(rowData.id, {
        schema: JSON.stringify(schema.client),
        view_table: schema.viewTable,
      });
    }
  };

  const handleKeyDown = (event: any, params: any) => {
    const isRowInEditMode =
      rowModesModel[params.id]?.mode === GridRowModes.Edit;

    // ESC → kilépés szerkesztésből mentés nélkül
    if (event.key === 'Escape' && isRowInEditMode) {
      event.preventDefault();
      event.stopPropagation();
      exitEditMode(params.id);
      return; // ne fusson tovább
    }

    if (event.key === 'Enter') {
      const fulfillment = isRowInEditMode
        ? {
          mode: GridRowModes.View,
          ignoreModifications: false,
        }
        : {
          mode: GridRowModes.Edit,
        };

      setRowModesModel((prevModel: any) => ({
        ...prevModel,
        [params.id]: fulfillment,
      }));
    }
  };

  const handleDebouncedResizeColumn = (params: any) => {
    const column = params.colDef.field;
    const width = params.width;
  };

  const debouncedResizeColumn = debounce(handleDebouncedResizeColumn, 500);

  const [showSendNotification, setShowSendNotification] = useState(false);

  useEffect(() => {
    if (schema?.name === 'Activity Reservation') {
      return;
    }
    onRowSelected(undefined);
    if (apiRef.current) {
      const selectedRows = apiRef.current.getSelectedRows();
      const array = [...selectedRows];
      array.map(([key, value]) => {
        apiRef?.current.selectRow(key, false);
      });
    }
    return;
  }, [searchParams, filterModel]);

  const handleFilterModelChange = useCallback((newModel: any) => {
    setFilterModelStatic((prevModel) =>
      JSON.stringify(prevModel) === JSON.stringify(newModel)
        ? prevModel
        : newModel
    );
  }, []);

  const handleSortModelChange = useCallback((newModel: any) => {
    setSortModelStatic((prevModel) =>
      JSON.stringify(prevModel) === JSON.stringify(newModel)
        ? prevModel
        : newModel
    );
  }, []);

  const handlePaginationModelChange = useCallback((newModel: any) => {
    setPaginationModelStatic((prevModel) =>
      JSON.stringify(prevModel) === JSON.stringify(newModel)
        ? prevModel
        : newModel
    );
  }, []);

  useEffect(() => {
    if (schema.viewTable !== 'groups') {
      return;
    }
    const selectedRows = apiRef.current.getSelectedRows();
    const array = [...selectedRows];
    if (apiRef.current) {
      array.map(([key, value]) => {
        apiRef.current.scrollToIndexes({rowIndex: key - 1});
      });
    }
  }, [selectedRowId]);

  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;

      // Ne zárjuk be, ha valami popup-elemben vagy selectben kattintottunk
      const isInMuiPopover =
        !!target.closest('.MuiAutocomplete-popper') ||
        !!target.closest('.MuiPopover-root') ||
        !!target.closest('.MuiMenu-paper') ||
        !!target.closest('.MuiDialog-container') ||
        !!target.closest('.MuiPopper-root') ||
        !!target.closest('[role="listbox"]');
      if (
        gridRef.current &&
        !gridRef.current.contains(target) &&
        !isInMuiPopover
      ) {
        closeAllEditRows();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [rowModesModel]);

  return (
    <>
      <TableHeader
        schema={schema}
        onEntityAdded={fetchData}
        newEntityFixedValues={newEntityFixedValues}
        showCSVImport={!!showCSVImport}
        fillOptions={schema.name == 'Activity Reservation'}
        fillOptionSend={fillOptionSend}
        rows={state.rows}
        selectedRowId={selectedRowId}
        selectedGroupId={selectedGroupId}
        setCurrentEditedRow={(row: any) => {
          if (setCurrentEditedRow) {
            setCurrentEditedRow(row);
          }
        }}
        setCurrentAddNewRow={(row: any) => {
          if (setCurrentAddNewRow) {
            setCurrentAddNewRow(row);
          }
        }}
        onSearchChange={(value: any) => {
          setFastSearchValue(value);
        }}
        quickFilterChange={(value: any) => {
          if (apiRef.current) {
            apiRef.current.setFilterModel({
              ...filterModel,
              quickFilterValues: value ? [value] : [],
            });
          }
        }}
        onFilterChange={(column, value) => {
          //itt
          setFastFilterValueServiceProvider({
            ...fastFilterValueServiceProvider,
            [`${column}`]: value,
          });
        }}
        onShowReservationsChange={() => {
          setCollapsed(!collapsed);
          if (onShowReservationsChange) {
            onShowReservationsChange();
          }
        }}
        showReservations={collapsed}
        disableSearch={state?.isLoading}
        isView={isView}
        loadingTable={state?.isLoading}
        hasPagination={false}
        rowCount={state.rowCount}
        paginationModel={paginationModel}
        onPageChange={(value) => {
          if (apiRef.current) {
            apiRef.current.setPage(value);
          }
          onRowSelected(undefined);
        }}
        onPageSizeChange={(value) => {
          if (apiRef.current) {
            apiRef.current.setPageSize(value);
          }
          onRowSelected(undefined);
        }}
        checkedRows={rowSelectionModel}
        changeCheckedRows={() => {
          setRowSelectionModel([]);
          fetchData();
        }}
        changeAllCheckedRows={(value: boolean) => {
          if (value) {
            const checkAllRow: any = {};
            const allRowId = apiRef.current.getAllRowIds();
            allRowId.map((rowId: any) => {
              checkAllRow[rowId] = apiRef.current.getRow(rowId);
            });
            setCheckedRows(checkAllRow);
          } else {
            setCheckedRows({});
          }
        }}
        sendChanges={(value: boolean) => {
          setState({...state, ['isLoading']: value});
        }}
        reservationDialog={reservationDialog}
        refreshTableData={() => fetchData()}
        onGuideFastSearchChange={(value) => {
          handleChangeFastFilter(1, 1000, {column: 'guides'}, value);
        }}
        onSalesPartnerSearchChange={(value) => {
          handleChangeFastFilter(1, 999, {column: 'sales_partner'}, value);
        }}
        handleOpenFilters={() => {
          setOpenFilters(!openFilters);
        }}
        progressPercent={progressPercent}
        apiRef={apiRef}
        handleDownloadMasterSettlementRiport={() => {
          handleDownloadMasterSettlementRiport();
        }}
        setPopupState={(value: any) => {
          setPopupState(value);
        }}
        setFilterOriginalAndFinalPrice={(value: any) => {
          setFilterOriginalAndFinalPrice(value);
        }}
        filterOriginalAndFinalPrice={filterOriginalAndFinalPrice}
        showDeleted={showDeleted}
        setShowDeleted={(value: any) => {
          setShowDeleted(value);
        }}
        exportToXLSX={() => {
          exportToXLSX(state.rows, columns, apiRef, schema, searchParams);
        }}
      />

      {schema?.filters && (
        <FastFilters
          schema={schema}
          fastFilters={fastFilters}
          fastFilterValue={fastFilterValue}
          handleChangeFastFilter={handleChangeFastFilter}
          disabled={false}
          isLoading={false}
        />
      )}

      <Box sx={datagridColors(datagridHeight, isMobile)} ref={boxRef}>
        {!collapsed && (
          <DataGridPro
            treeData={schema?.treeData}
            getTreeDataPath={getTreeDataPath}
            disableChildrenSorting
            disableDensitySelector
            // disableColumnFilter
            hideFooter={true}
            slots={{
              // @ts-ignore
              columnMenu: CustomColumnMenu,
              columnSortedDescendingIcon: CustomSortIconDesc,
              columnSortedAscendingIcon: CustomSortIconAsc,
              columnUnsortedIcon: CustomSortIcon,
              footer: CustomFooter,
              //toolbar: CustomToolbar,
              filterIcon: FilterList,
              headerFilterMenu: null,
              /* noRowsOverlay: CustomNoRowsOverlay,*/
            }}
            apiRef={apiRef}
            ref={gridRef}
            getRowHeight={getRowHeight}
            getRowId={(row: any) => {
              return row?.row_number ? row?.row_number : row.id;
            }}
            slotProps={{
              row: {
                onContextMenu: (e: any) => {
                  handleRowContextMenu(e);
                },
              },
              toolbar: {
                showQuickFilter: true,
              },
            }}
            rows={state?.rows}
            columns={columns}
            getRowClassName={(params: any) => {
              const color = 'odd';

              const collapse = params.row?.is_group_item ? ' light-blue' : '';
              const openedTreeGroup = params.row?.is_group
                ? 'light-blue-header'
                : '';

              const deletedRow = params.row?.deleted_at ? 'deleted-row' : '';
              const footerRow = params.row?.is_footer ? 'footer-row' : '';

              const typeColor = params.row?.type_color
                ? params.row?.type_color
                : '';

              const highlightColor =
                schema?.hasCheckField && params.id === selectedRowId?.id
                  ? 'Mui-selected'
                  : '';

              const redHighlightColor =
                schema?.name === 'Activity Reservation' &&
                params?.row?.sales_partner?.id === 5
                  ? 'text-color-red'
                  : '';

              const statusColor = params?.row?.status_color
                ? params?.row?.status_color
                : '';

              const freeActivityColor = params?.row?.free
                ? 'text-color-green'
                : '';

              const highlightedView = params?.row?.id
                ? highlightedRows.includes(params.row.id)
                  ? 'highlighted-border'
                  : ''
                : '';

              return `${color} ${collapse} ${openedTreeGroup} ${deletedRow} ${footerRow} ${typeColor} ${highlightColor} ${redHighlightColor} ${statusColor} ${highlightedView} ${freeActivityColor}`;
            }}
            density="compact"
            getCellClassName={(params: any) => {
              const colorClass =
                params.row?.id_color && params.field === 'actions'
                  ? params.row?.id_color
                  : '';
              const groupName =
                schema?.name.toLowerCase() === 'group' &&
                params.field === 'name'
                  ? 'blue-colored-cell'
                  : '';
              /* const groupGuide =
                 schema?.name.toLowerCase() === 'group' &&
                 params.field === 'guides'
                   ? 'green-colored-cell'
                   : '';*/

              const groupColorClass =
                params.row?.group_cell_color && params.field === 'group'
                  ? params.row?.group_cell_color
                  : '';

              const activtyColorClass =
                params.row?.activity_cell_color && params.field === 'activity'
                  ? params.row?.activity_cell_color
                  : '';

              const subRow =
                params?.row?.is_group_item && params?.field === 'name'
                  ? 'sub-row'
                  : '';
              const hasPriceDiff =
                params?.row?.has_price_diff &&
                (params?.field === 'final_price_pp' ||
                  params?.field === 'final_cost')
                  ? 'has-price-diff'
                  : '';

              const bbcolorClass =
                params.row?.accom_color &&
                params.field === 'accommodation_names'
                  ? params.row?.accom_color
                  : '';

              const redColoredPickupTime =
                schema?.viewTable === 'activity_reservations' &&
                params.field === 'pickup_time' &&
                params.row?.red_colored_time
                  ? 'red-colored-cell'
                  : '';
              return `${colorClass} ${bbcolorClass} ${groupName} ${groupColorClass} ${activtyColorClass} ${subRow} ${hasPriceDiff} ${redColoredPickupTime}`;
            }}
            onRowClick={handleRowClick}
            onRowDoubleClick={handleRowDoubleClick}
            pinnedColumns={pinnedColumns}
            onColumnOrderChange={(params: any, event: any, details: any) => {
              reorderColumns(params?.oldIndex - 1, params?.targetIndex - 1);
            }}
            onPinnedColumnsChange={handleColumnPinned}
            pagination
            hideFooterSelectedRowCount
            pinnedRows={pinnedRows}
            columnVisibilityModel={visibleColumns}
            defaultGroupingExpansionDepth={-1}
            loading={state?.isLoading}
            editMode={'row'}
            rowModesModel={rowModesModel}
            unstable_headerFilters={openHeaderFilters}
            columnBuffer={50}
            processRowUpdate={processRowUpdate}
            onProcessRowUpdateError={handleProcessRowUpdateError}
            onStateChange={handleStateChange}
            checkboxSelection={schema?.hasCheckField}
            disableRowSelectionOnClick={schema?.hasCheckField}
            checkboxSelectionVisibleOnly={true}
            onRowSelectionModelChange={(rowSelectionModel, details) => {
              if (schema.hasCheckField) {
                if (!openedPanel) {
                  setRowSelectionModel(rowSelectionModel);
                }
              } else {
                setRowSelectionModel(rowSelectionModel);
              }
            }}
            rowSelectionModel={rowSelectionModel}
            onCellKeyDown={(params, event) => handleKeyDown(event, params)}
            pageSizeOptions={[
              25,
              50,
              100,
              {label: 'All', value: state?.rows?.length},
            ]}
            autosizeOptions={{
              includeOutliers: true,
              includeHeaders: false,
            }}
            onColumnWidthChange={debouncedResizeColumn}
            filterMode={'client'}
            disableChildrenFiltering={true}
            onFilterModelChange={handleFilterModelChange}
            sortingMode={'client'}
            onSortModelChange={handleSortModelChange}
            disableMultipleColumnsSorting={false}
            onPaginationModelChange={handlePaginationModelChange}
            isCellEditable={(params) => {
              let returnValue = true;

              if (schema?.viewTable === 'service_reservations' && params.field === 'selected_staff') {
                returnValue = false;
                if (params?.row?.is_guide && !params?.row?.selected_staff?.id){
                  returnValue = true;
                }
              }

              return returnValue;
            }}
            columnHeaderHeight={40}
          />
        )}
      </Box>

      {contextMenu && (
        <FloatingMenu
          anchorPosition={{top: contextMenu.mouseY, left: contextMenu.mouseX}}
          rightClickedRow={rightClickedRow}
          schema={schema}
          setContextMenu={() => setContextMenu(null)}
          setCurrentEditedRow={(value, type) => {
            const isRowUnderEdit: any = handleCheckRowLockStatus(value.id);
            if (setCurrentEditedRow) {
              let isLocked = isRowUnderEdit.locked;
              if (isRowUnderEdit.locked) {
                toast.error(
                  <>
                    <p>
                      This row is already under edit by:{' '}
                      <b>{isRowUnderEdit?.row?.user?.name}</b>
                    </p>
                  </>
                );
              } else {
                schema.client.lock(value?.id, {
                  schema: JSON.stringify(schema.client),
                  view_table: schema.viewTable,
                });
                if (schema.name === 'Service Reservations View') {
                  api
                    .post(`/notifications/service-reservation/${value?.id}`, {})
                    .then((result: any) => {
                      setState((prevState: any) => ({
                        ...prevState,
                        rows: prevState.rows.map((row: any) =>
                          row.id === value?.id
                            ? {...row, notification_count: false}
                            : row
                        ),
                      }));
                    });
                }
              }
              setCurrentEditedRow(value, type, isLocked);
            }
          }}
          deleteClick={(row: any) => {
            setOpenConfirmDialog(row);
          }}
          duplicateClick={(row: any) => {
            setOpenDuplicateConfirmDialog(row);
          }}
          openReservations={(row: any) => {
            setOpenedReservations(row);
          }}
          openModifications={() => {
            setShowSendNotification(true);
          }}
          generateReservationClipboardData={(row: any) => {
            handleGenerateClipboardData(row);
          }}
          openGuideOptions={(row: any) => {
            setOpenedGuideOptions(row);
          }}
          openLogs={(row: any) => {
            setOpenedLogs(row);
          }}
          fillOptionSend={(row: any, type: string) => {
            fillOptionActivityReservationSend(row, type);
          }}
          restoreClick={(row: any) => {
            restoreHandleClick(row?.id, schema);
          }}
          refreshStatuses={(row: any) => {
            //refreshStatusHandleClick(row);
          }}
          isInFullPanel={isInFullPanel}
        />
      )}

      {popupState && (
        <ColumnMenu
          popupState={popupState}
          anchorEl={boxRef}
          visibleColumns={visibleColumns}
          sortedColumns={sortedColumns}
          schema={schema}
          setPopupState={(value) => {
            setPopupState(value);
          }}
          viewId={viewId ? viewId : subViewId}
          apiRef={apiRef}
          setVisibleColumns={(value) => {
            setVisibleColumns(value);
          }}
        />
      )}

      {openedReservations && (
        <ReservationDialog
          row={openedReservations}
          handleClose={() => {
            setOpenedReservations(false);
          }}
        />
      )}

      {openConfirmDialog && (
        <ConfirmDialog
          open={openConfirmDialog}
          onClose={() => setOpenConfirmDialog(false)}
          onConfirm={(message:any, files:any) => {
            setOpenConfirmDialog(false);

            let formData = new FormData();
            files.forEach((file: any, i: any) => {
              formData.append(`file-${i}`, file);
            });

            formData.append('message', message);

            toast
              .promise(
                schema.client.deleteWithFiles(openConfirmDialog.id as number,formData),
                {
                  loading: 'Deleting...',
                  success: isAdmin
                    ? 'Successfully deleted!'
                    : 'Your request to delete this item is pending approval',
                  error: 'Unable to delete.',
                }
              )
              .then(() => {
                fetchData();
              }).catch((error:any)=>{
                if (error?.message){
                  toast.error(error.message);
                }
            });
          }}
          title="Are you sure you want to delete it?"
          description={openConfirmDialog.name}
        />
      )}

      {openDuplicateConfirmDialog && (
        <ConfirmDialog
          open={openDuplicateConfirmDialog}
          onClose={() => setOpenDuplicateConfirmDialog(false)}
          onConfirm={() => {
            setOpenDuplicateConfirmDialog(false);
            duplicateHandleClick(openDuplicateConfirmDialog?.id, schema);
          }}
          confirmText={'Yes'}
          cancelText={'No'}
          title="Do you want to duplicate this element?"
          description={openConfirmDialog.name}
        />
      )}

      {showSendNotification && (
        <ServiceReservationModificationDialog
          type={'all'}
          values={rowSelectionModel}
          onClose={() => {
            setShowSendNotification(false);
          }}
          onUpdatedRows={(rows: any) => {
            if (rows && rows?.length) {
              setState((prevState: any) => ({
                ...prevState,
                rows: prevState.rows.map((row: any) => {
                  const updated = rows.find((r: any) => r.id === row.id);
                  return updated ? {...row, ...updated} : row;
                }),
              }));
            }
          }}
        />
      )}

      {pendingRowUpdate && (
        <>
          {pendingRowUpdate?.type === 'time' && (
            <PendingRowUpdateDialog
              open={true}
              data={pendingRowUpdate?.oldRow}
              onClose={() => {
                handleConfirm(false);
              }}
              onConfirm={() => {
                handleConfirm(true);
              }}
            />
          )}

          {pendingRowUpdate?.type === 'status' && (
            <PendingRowUpdateStatusDialog
              open={true}
              data={pendingRowUpdate?.oldRow}
              onClose={() => {
                handleConfirm(false);
              }}
              onConfirm={() => {
                handleConfirm(true);
              }}
            />
          )}
          {pendingRowUpdate?.type === 'sp_status' && (
            <ConfirmDialog
              open={true}
              onClose={() => {
                handleConfirm(false);
              }}
              onConfirm={() => {
                handleConfirm(true);
              }}
              confirmText={'Yes'}
              cancelText={'No'}
              title="This action changes the types of the reservations, therefore it changes their statuses. Do you want to continue?"
              description={''}
            />
          )}
        </>
      )}

      {openedGuideOptions && (
        <GuideOptions
          row={openedGuideOptions}
          handleClose={() => {
            setOpenedGuideOptions(false);
          }}
          schema={schema}
        />
      )}
      {openedLogs && (
        <LogDialog
          row={openedLogs}
          onClose={() => {
            setOpenedLogs(false);
          }}
          schema={schema}
          equals={true}
        />
      )}
      {openAttachmentDialog && (
        <AttachmentDialog
          open={true}
          onClose={() => {
            setOpenAttachmentDialog(false);
          }}
          row={openAttachmentDialog}
        />
      )}
    </>
  );
}

function sleep(ms: number) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}
